export const model = {
    id: null,
    name: "",
    slug: "",
    parent_id: "",
    enabled: "",
    created_at: '',
    updated_at: ''
};
